/** Início do portal: o que precisa de você, o que tem para pagar, o que está em andamento e as novidades. */
import { createFileRoute } from '@tanstack/react-router';
import { ComPortal } from '../telas/portal/casca';
import { Inicio } from '../telas/portal/inicio';

export const Route = createFileRoute('/portal/')({ component: () => <ComPortal>{(d, eu) => <Inicio d={d} eu={eu} />}</ComPortal> });
